// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__65n75","type":"styles_type__fVSDh","choices":"styles_choices__3CxgF"};